import {useFormContext} from 'react-hook-form'

import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'

const CheckboxInput = ({label, name, options = {}, ...props}) => {
  const {register} = useFormContext()

  return (
    <FormControlLabel
      control={<Checkbox sx={{color: '#4E9E9A'}} />}
      label={label}
      {...register(name, options)}
      {...props}
    />
  )
}

export default CheckboxInput
